import { FC } from "react";
import "./amr-meter-group.scss";
import { MeterGroup } from 'primereact/metergroup';

interface AmrMeterGroupProps {
    values: { label: string, value: number, color: string }[];
}

const AmrMeterGroup:FC<AmrMeterGroupProps> = ({values}) => {
    const total = values.reduce((sum, value) => sum + value.value, 0);
    return (
        <div className="amr-meter-group">
            <div className="amr-meter-group__total">
                <div className="amr-meter-group__total__value">
                    {total}
                </div>
                <div className="amr-meter-group__total__label">
                    products
                </div>
            </div>
            <div className="amr-meter-group__gauges">
                {values.map((value) =>(
                    <div key={value.color} style={{ width: `${value.value/total*100}%`,height:'0.5rem', backgroundColor:value.color, borderRadius:'3px' }}>
                    </div>
                ))}
            </div>
            <div className="amr-meter-group__legends">
                {values.map((value) =>(
                    <div className="amr-meter-group__legends__legend" key={value.color}>
                        <div style={{ width: '8px',height:'8px', borderRadius:'50%', backgroundColor:value.color }}>
                        </div>
                        <div style={{color:value.color }}>{`${value.label} : `}</div>
                        <div>{value.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AmrMeterGroup;
